/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-task-resolver',
  template: '',
  standalone: false
})
export class TasksResolver implements OnInit {
  data: any;
  currentTaskId: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.currentTaskId = params.taskId;
    });
    this.route.queryParams.subscribe((params) => {
      this.data = params;
    });
    if (!this.currentTaskId || this.currentTaskId == '') {
      this.router.navigate([`home/tasks/activities`], {
        queryParams: this.data
      });
    } else {
      this.router.navigate([`home/tasks/activities/${this.currentTaskId}`], {
        queryParams: this.data
      });
    }
  }
}
